import React from 'react';
import { Box, Card, FlexBox, Icon, Typography } from '@vp/swan';

interface ValidationCardProps {
  cardTitle?: string;
  cardMessage: string;
  type: 'error' | 'warning';
}

export const ValidationCard = ({ cardTitle, cardMessage, type }: ValidationCardProps) => {
  return (
    <Card bgc="error" mb={4} p={5}>
      <FlexBox>
        <Icon iconType={type === 'warning' ? 'info' : 'error'} skin={type === 'warning' ? 'warning' : 'error'} />
        <Box ml={4}>
          {cardTitle && (
            <Typography mb={1} fontSkin="title-item">
              {cardTitle}
            </Typography>
          )}
          <Typography fontWeight="normal">{cardMessage}</Typography>
        </Box>
      </FlexBox>
    </Card>
  );
};
